import { ShowDialogProps } from 'src/show-dialog'
import { ProductCertificationListForm } from './ProductCertificationListForm'

interface CertificationListDialogProps extends ShowDialogProps {
  productId: EntityId
}
export const CertificationListDialog: React.FC<CertificationListDialogProps> = ({ pop, productId }) => {
  return <ProductCertificationListForm productId={productId} pop={pop} />
}
